export default __webpack_public_path__ + "static/media/moisture.d7416b84.svg";